import { render, staticRenderFns } from "./PackAndDispatchPage.vue?vue&type=template&id=4bb9fe0c&scoped=true&"
import script from "./PackAndDispatchPage.vue?vue&type=script&lang=js&"
export * from "./PackAndDispatchPage.vue?vue&type=script&lang=js&"
import style0 from "./PackAndDispatchPage.vue?vue&type=style&index=0&id=4bb9fe0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb9fe0c",
  null
  
)

export default component.exports